// NewCity.js
import React, { use, useState , useEffect} from "react";
import { useNavigate } from "react-router-dom";
import  "../index.css";
import Select from "react-select";
import { SaveIcon, Search } from "lucide-react";
import config from "./config";
import { getProfileFromToken } from "./config";
import MHeader from "./header";
import Mfooter from "./footer";

let bearer;
function NewCity({user, setUser, setPass,setBea }) {

  const navigate = useNavigate();
  let profile = getProfileFromToken();
  if (profile!=="Admin")
  { 
    navigate ("/");
  }
  
  const [nome, setNome] = useState('');
  const [descrizione, setDescrizione] = useState('');
  const [indirizzo, setIndirizzo] = useState('');
  const [lat, setLat] = useState('');
  const [lng, setLng] = useState('');
  const [linkMappaGenerico, setLinkMappaGenerico] = useState('');

  
  const handleNomeChange = (event) => {
    setNome(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

   
    const formData = new FormData();
    formData.append('nome', nome);
    formData.append('descrizione', descrizione);
    formData.append('indirizzo', indirizzo);
    formData.append('lat', lat);
    formData.append('lng', lng);
    formData.append('link_mappa_generico', linkMappaGenerico);
   

    try {
      const response = await fetch(config.apiUrl+'/newluogo', {
        method: 'POST',
        headers: {
            "Authorization": "Bearer "+localStorage.getItem("token")
          },
        body: formData,
      });

      if (response.ok) {
        //const data = await response.json();
        alert(`File caricato con successo...`);
        navigate("/");
      } else {
        alert('Errore durante il caricamento del file.');
      }
    } catch (error) {
      console.error('Errore:', error);
      alert('Si è verificato un errore durante il caricamento.');
    }
  };

  return (
    <div className="App">
          <h2  className="App-header">{config.appName}</h2>
          <MHeader/>
          <p><small>utente: {user}</small></p>
          <div className="relative"></div>
         <h2>Aggiungi un nuovo luogo</h2>
    <div style={{ border: '1px solid #ccc', padding: '1rem', margin: '1rem 0', borderRadius: '8px' }}>
    <form onSubmit={handleSubmit}>
      {/* Nome */}
        <div>
          <label>Nome Luogo:</label><p></p>
          <input
            type="text"
            value={nome}
            onChange={(e) => setNome(e.target.value)}
            required
          />
        </div>

        {/* Descrizione */}
        <div>
          <label>Descrizione:</label><p></p>
          <textarea
            value={descrizione}
            onChange={(e) => setDescrizione(e.target.value)}
            rows="4"
          />
        </div>

        {/* Indirizzo */}
        <div>
          <label>Indirizzo:</label><p></p>
          <input
            type="text"
            value={indirizzo}
            onChange={(e) => setIndirizzo(e.target.value)}
          />
        </div>

        {/* Latitudine */}
        <div>
          <label>Latitudine:</label><p></p>
          <input
            type="text"
            value={lat}
            onChange={(e) => setLat(e.target.value)}
          />
        </div>

        {/* Longitudine */}
        <div>
          <label>Longitudine:</label><p></p>
          <input
            type="text"
            value={lng}
            onChange={(e) => setLng(e.target.value)}
          />
        </div>

        {/* Link Mappa */}
        <div>
          <label>Link Mappa Generico:</label><p></p>
          <input
            type="text" // o "url"
            value={linkMappaGenerico}
            onChange={(e) => setLinkMappaGenerico(e.target.value)}
          />
        </div>
        
        <button type="submit"><SaveIcon className="mr-2" /><br/>Salva Luogo</button><p>
      </p>
    </form>
    </div>
      <Mfooter/>
    </div>
  );
}
export default NewCity;